import {AvailableData} from "./AvailableData";
import {MutableRuleAbstract} from "./MutableRuleAbstract";
import {ICondition, IObjectType, IRule} from "../../../../index";

interface IRuleMutable {
    getArgumentType: () => ICondition['type']
    attribute: KnockoutObservable<IRule['attribute'] | null>
    argument: KnockoutObservable<IRule['argument'] | null>
    argumentoperator: KnockoutObservable<IRule['argumentoperator'] | null>
    availableData: AvailableData
}

interface IRulePartParams {
    data: MutableRuleAbstract
    objectType: KnockoutObservable<IObjectType>
}
